import React from "react";
import OnuImg1 from "../../../../assets/images/onuFiberhome.jpg";

import './styles.css';

const Onu = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>Onu</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={OnuImg1} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Onu;